<template>
  <b-card>
    <ListConcedenteContatos :concedente_id="concedente.id" open-edit-in-modal />
  </b-card>
</template>

<script setup>
import ListConcedenteContatos from "@/modules/concedentes_contatos/pages/List.vue";
import { useNamespacedState } from "vuex-composition-helpers";

const { concedente } = useNamespacedState("concedentes", ["concedente"]);
</script>
